"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _excluded = ["loading", "type", "size", "submit", "children", "className"];
var isPrimaryStyle = (0, _eq["default"])('primary');
var isRegularSize = function isRegularSize(size) {
  return (0, _eq["default"])('md')(size) || (0, _isNil["default"])(size);
};
var Button = function Button(_ref, ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    size = _ref.size,
    submit = _ref.submit,
    children = _ref.children,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classnames["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
    btn: true
  }, "btn-".concat(type), !isPrimaryStyle(type)), "btn-".concat(size), !isRegularSize(size)), "loading", loading), className);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    type: submit ? 'submit' : 'button',
    className: classes,
    "aria-label": loading && (0, _isString["default"])(children) ? children : undefined,
    "data-testid": "button-root",
    ref: ref
  }, rest), loading ? null : children);
};
var ForwardRefButton = /*#__PURE__*/_react["default"].forwardRef(Button);
var _default = exports["default"] = ForwardRefButton;